<template>
  <header :class="`header ${getHeaderClass}`">
    <transition name="fade">
      <div v-show="showMobileMenu" class="mobile-menu pageIn" key="0">
        <div class="mobile-bg"></div>
        <div class="nav-btn-toggle">
            <div class="bounceUpIn" style="display:flex;align-items:center;justify-content:space-around;margin-top:20px;position:relative;z-index:1">
                <ul
                    class="menu mobile-tabbar"
                    style="justify-content:center;align-items:center;padding:5px 0"
                    v-if="userInfo.user_id"
                >
                    <!-- <div style="cursor:pointer" @click="toBoxWallet">
                    <div class="vertical-children">
                        <img width="20" src="../../assets/home/wallet.png" alt=""> 
                        <span id="box-name" style="margin-left:10px">BOX</span>
                    </div>
                    </div> -->
                    <!-- <router-link to="/userCenter"> -->
                    <li class="user-info">
                    <!-- 头像 -->
                    <div class="user-head">
                        <!-- <img src="../../assets/icon/userSystem/head.png" alt="" /> -->
                    </div>
                    <span id="user-head-name">{{
                        userInfo.nickname || userInfo.user_id
                    }}</span>
                    <div class="sanjiao"></div>
                    </li>
                    <div class="user-menu">
                    <!-- <div @click="doUserMenu(0)" class="user-menu-item">
                        <div class="item-left">
                        <span class="label-head"></span>
                        <div>User Center</div>
                        </div>
                        <div class="sanjiao"></div>
                    </div>

                    <div @click="doUserMenu(1)" class="user-menu-item">
                        <div class="item-left">
                        <span class="label-head"></span>
                        <div>BOX Wallet</div>
                        </div>
                        <div class="sanjiao"></div>
                    </div> -->

                    <div @click="logout" class="user-menu-logout">
                        <!-- <img src="@/assets/home/logout.png" alt="" /> -->
                        <div>Log Out</div>
                    </div>
                    </div>
                    <!-- </router-link> -->
                    <!-- <li @click="logout">{{$t('Register_40')}}</li> -->
                </ul>
                <ul class="menu mobile-tabbar" style="padding:10px 20px;flex-direction:row" v-else>
                    <li style="color:white" @click="toggleLoginModal">Login</li>
                    <li style="color:white" @click="showShowRegister" class="register">Register</li>
                </ul>

                <div class="downarea mobile-tabbar" style="padding:10px">
                    <div class="select-area">
                    <div style="margin-right:10px;font-size:15px">Download</div>
                    <div class="sanjiao"></div>
                    </div>
                    <div class="down-menu">
                    <div class="downlaod-itembox code-box">
                        <!-- <div ref="iosqrcode"></div> -->
                        <img class="qrcode" src="@/assets/index/header/downallcode.png" alt="" />
                        <div>{{ `iOS Download Android Download` }}</div>
                    </div>
                    <!-- <div v-show="isChin">
                        <div class="downlaod-itembox code-box">
                        <div ref="iosqrcode"></div>
                        <div>iOS Download</div>
                        </div>
                        <div class="downlaod-itembox code-box">
                        <div ref="andqrcode"></div>
                        <div>Android Download</div>
                        </div>
                    </div> -->

                    <div class="line"></div>

                    <div @click="toDownLoad" style="padding: 8px 16px" class="btn-2">
                        More Download
                    </div>
                    </div>
                </div>
            </div>

            <div v-if="showLang" class="lang-area" style="margin-top:20px">
              <Dropdown
                :list="langArr"
                :defaultSelectPos="defaultSelectLangPos"
                :onChange="onLangChange"
                :direction="'down'"
              />
            </div>


          <ul style="margin-top: 20px">
            <li class="bounceUpIn" to="/" tag="li" exact>Home</li>
            <li class="bounceUpIn" style="animation-delay:0.1s">MOMO Farmer</li>
            <li class="menu-item bounceUpIn" style="animation-delay:0.2s">
              <div class="nav-box">Games</div>
              <div class="mobile-sub-menu">
                <a class="bounceUpIn" style="animation-delay:0.3s" :href="`${getPage}#/iframe/chainzarena`">
                  ChainZ Arena
                </a>
                <a class="bounceUpIn" style="animation-delay:0.3s" :href="`${getPage}#/iframe/mobox_tower_defense`">
                  MOland Defense
                </a>
                <a class="bounceUpIn" style="animation-delay:0.3s" :href="`${getPage}#/block-brawler`">
                  Block Brawler
                </a>
                <a class="bounceUpIn" style="animation-delay:0.4s" :href="`${getPage}#/iframe/tokenmaster`">
                  Token Master
                </a>
                <!-- <a class="bounceUpIn" style="animation-delay:0.5s" :href="`${getPage}#/iframe/contest`">
                  Trade Action
                </a> -->
              </div>
            </li>
            <!-- nft市场 -->
            <li class="bounceUpIn" style="animation-delay:0.6s" to="/iframe/momo?path=market&tab=0" tag="li">
              NFT Marketplace
            </li>
            <!-- 治理 -->
            <li class="menu-item">
              <div class="nav-box bounceUpIn" style="animation-delay:0.7s" >Governance</div>
              <div class="mobile-sub-menu">
                <a class="bounceUpIn" style="animation-delay:0.8s" :href="`${getPage}#/governance/list?tab=momo`">
                  Vote
                </a>
                <a class="bounceUpIn" style="animation-delay:0.9s" :href="`https://www.mobox.io/community/`"> Community </a>
              </div>
            </li>
            <!-- <div @click="goToGameDetail('momo')" class="li-class" tag="li"> {{$t('Home_2')}}</div>
                        <div @click="goToGameDetail('market')" class="li-class" tag="li"> {{$t('Home_3')}}</div> -->
            <li @click="toLink(`docs`)" class="mobile-li-class bounceUpIn" style="animation-delay:0.9s">Docs</li>
            <!-- <li>NFT市场</li> -->
            <!-- <div :to="{ path: '/', query: { userId: 1111}}" tag="li"> {{$t('Home_53')}}</div> -->
            <!-- <div to="/feedback" tag="li"><span class="label-head"></span> {{$t('Setting_66')}}</div> -->
          </ul>

          <div class="head-footer">
            <a target="_blank" href="https://twitter.com/MOBOX_Official"
              ><img type="twitter" src="@/assets/index/footer/twitter.png"
            /></a>
            <a target="_blank" href="https://t.me/mobox_io"
              ><img type="tele" src="@/assets/index/footer/telegram.png"
            /></a>
            <a target="_blank" href="https://discord.gg/gW2eAU4WZy"
              ><img type="kakao" src="@/assets/index/footer/discord.png"
            /></a>
          </div>
        </div>
      </div>
    </transition>

    <div class="header-elements">
      <div class="mobile-btns mobile-state">
        <div @click="openToggle(true)" v-if="!showMobileMenu" class="nav-btn">
          <svg width="23" height="23" viewBox="0 0 16 16" style="fill: #fff">
            <path
              d="M.571 3.571H15.43A.571.571 0 0016 3V1.571A.571.571 0 0015.429 1H.57A.571.571 0 000 1.571V3c0 .316.256.571.571.571zm0 5.715H15.43A.571.571 0 0016 8.714V7.286a.571.571 0 00-.571-.572H.57A.571.571 0 000 7.286v1.428c0 .316.256.572.571.572zm0 5.714H15.43a.571.571 0 00.571-.571V13a.571.571 0 00-.571-.571H.57A.571.571 0 000 13v1.429c0 .315.256.571.571.571z"
            ></path>
          </svg>
        </div>

        <div @click="openToggle(false)" v-else class="close"></div>
      </div>

      <img class="logo" src="@/assets/index/head1.png" alt="" />

      <div @click="toLink(`farm`)" class="select-item pc-state">MOMO Farmer</div>
      <div class="select-item nav-select pc-state">
        <div>Games</div>
        <div class="sub-menu">
          <!-- cz -->
          <div @click="toGame(`cz`)" class="sub-menu-item">
            <div class="sub-menu-box" to="/block-brawler">
              <img
                class="logo"
                src="@/assets/chainzarena/logo.png"
                alt=""
              />
              <span class="name">ChainZ Arena</span>
              <i class="iconfont">&#xe60e;</i>
            </div>
          </div>
          <!-- tower defense -->
          <div @click="toGame(`towerdefense`)" class="sub-menu-item">
            <div class="sub-menu-box" to="/block-brawler">
              <img
                class="logo"
                src="@/assets/towerdefense/tdlogo.png"
                alt=""
              />
              <span class="name">MOland Defense</span>
              <i class="iconfont">&#xe60e;</i>
            </div>
          </div>
          <!-- 区块战争 -->
          <div @click="toGame(`block`)" class="sub-menu-item">
            <div class="sub-menu-box" to="/block-brawler">
              <img
                class="logo"
                src="@/assets/index/block-brawler-logo.png"
                alt=""
              />
              <span class="name">Block Brawler</span>
              <i class="iconfont">&#xe60e;</i>
            </div>
          </div>
          <!-- 金币大师 -->
          <div @click="toGame(`token`)" class="sub-menu-item">
            <div class="sub-menu-box" to="/iframe/tokenmaster">
              <img
                class="logo"
                src="@/assets/index/token-master-logo.png"
                alt=""
              />
              <span class="name">Token Master</span>
              <i class="iconfont">&#xe60e;</i>
            </div>
          </div>
          <!-- 模拟比赛 -->
          <!-- <div @click="toGame(`contest`)" class="sub-menu-item">
            <div class="sub-menu-box" to="/iframe/contest">
              <img class="logo" src="@/assets/index/contest-logo.png" alt="" />
              <span class="name">Trade Action</span>
              <i class="iconfont">&#xe60e;</i>
            </div>
          </div> -->
        </div>
      </div>
      <div @click="toLink(`nftmarket`)" class="select-item pc-state">
        NFT Marketplace
      </div>
      <div class="select-item nav-select pc-state">
        <div>Governance</div>
        <div class="sub-menu">
          <div @click="toGover(`vote`)" class="sub-menu-item">
            <div class="sub-menu-box">
              <span class="name">Vote</span>
              <i class="iconfont">&#xe60e;</i>
            </div>
          </div>
          <div @click="toGover(`community`)" class="sub-menu-item">
            <div class="sub-menu-box" target="_blank">
              <span class="name">Community</span>
              <i class="iconfont">&#xe60e;</i>
            </div>
          </div>
        </div>
      </div>
      <div @click="toLink(`docs`)" class="select-item pc-state">Docs</div>
    </div>

    <div class="right-menu">
        <ul
        class="menu pc-state"
        style="justify-content: center; align-items: center"
        v-if="userInfo.user_id"
        >
        <li class="user-info">
            <div class="user-head">
            <!-- <img src="../../assets/icon/userSystem/head.png" alt="" /> -->
            </div>
            <span id="user-head-name">{{
            userInfo.nickname || userInfo.user_id
            }}</span>
            <div class="sanjiao"></div>
        </li>
        <div class="user-menu">
            <!-- <div @click="doUserMenu(0)" class="user-menu-item">
            <div class="item-left">
                <span class="label-head"></span>
                <div>User Center</div>
            </div>
            <div class="sanjiao"></div>
            </div>

            <div @click="doUserMenu(1)" class="user-menu-item">
            <div class="item-left">
                <span class="label-head"></span>
                <div>BOX Wallet</div>
            </div>
            <div class="sanjiao"></div>
            </div> -->

            <div @click="logout" class="user-menu-logout">
            <!-- <img src="@/assets/home/logout.png" alt="" /> -->
            <div>Log Out</div>
            </div>
        </div>
        </ul>
        <ul class="menu pc-state" v-else>
        <li @click="toggleLoginModal">Login</li>
        <li @click="showShowRegister" class="register">Register</li>
        </ul>
        <div class="downarea pc-state">
        <div class="select-area">
            <div>Download</div>
            <div class="sanjiao"></div>
        </div>

        <div class="down-menu">
            <div class="downlaod-itembox code-box">
            <img class="qrcode" src="@/assets/index/header/downallcode.png" alt="" />
            <div>{{ `iOS Download Android Download` }}</div>
            </div>
            <!-- <div v-show="isChin">
            <div class="downlaod-itembox code-box">
                <div ref="iosqrcode"></div>
                <div style="margin: 5px 0">iOS Download</div>
            </div>
            <div class="downlaod-itembox code-box">
                <div ref="andqrcode"></div>
                <div style="margin: 5px 0">Android Download</div>
            </div>
            </div> -->

            <div class="line"></div>

            <div @click="toDownLoad" style="padding: 8px 16px" class="btn-2">
                More Download
            </div>
        </div>
        </div>

        <div v-if="showLang" class="lang-area">
          <Dropdown
            :list="langArr"
            :defaultSelectPos="defaultSelectLangPos"
            :onChange="onLangChange"
            :direction="'down'"
          />
        </div>
    </div>

    <!-- 注册 -->
    <Dialog v-model="isShowRegister">
      <Register ref="register" />
    </Dialog>
    <!-- 登录 -->
    <Dialog v-model="isShowLogin">
      <Login />
    </Dialog>
    
  </header>
</template>

<script>
import { mapState } from "vuex";
import Dialog from "@/components/Dialog.vue";
import Login from "@/components/Login/index.vue";
import Register from "@/components/Register/index.vue";
import { Common } from "@/utils";
import Dropdown from "@/components/Dropdown";
import {OLDPAGE} from '@/utils/constant'

const $ = window.$;

export default {
    components:{
        Dialog,
        Login,
        Register,
        Dropdown
    },

  data() {
    return {
      langArr: ["English", "繁體中文", "한국어", "français", "Português", "Tiếng Việt"],
      langNameToPos: ["en", "zh-CN", "kr", "fr", "po", "vn"],
      defaultSelectLangPos: 1,

      isShowRegister: false,
      showMobileMenu: false,
      isShowLogin: !!Common.getUrlParams("login"),

      nextVersion:false,
      showLang:false
    };
  },

  computed: {
    ...mapState({
      // 市值
      inGame: (state) => state.globalState.inGame,
      userInfo: (state) => state.globalState.userInfo,
    }),


    getPage(){
      return OLDPAGE
    },

    getHeaderClass() {
      return this.inGame ? `hide-header` : ``;
    },
  },

  created(){
    this.setLang();
  },

    mounted(){

      if(this.$route.path=="/binancemini"){
        this.showLang=true
      }
    },

  methods: {
    // 设置语言
    setLang() {
      let lang = Common.getStorageItem("lang") || "en";
      this.$store.commit("globalState/setLang", lang);

      this.defaultSelectLangPos = this.langNameToPos.indexOf(lang);
      console.log("?!!!?!?!?")
      console.log(this.defaultSelectLangPos)

      if (this.defaultSelectLangPos == -1) this.defaultSelectLangPos = 0;
    },
    // 语言切换
    onLangChange(index) {
      console.log(index)
      let lang = this.langNameToPos[index];
      Common.setStorageItem("lang", lang);
      this.$store.commit("globalState/setLang", lang);
      this.$i18n.locale = lang;
      // this.postMessage("changeLang", this.$i18n.locale);
    },
      // 显示注册
    showShowRegister() {
        this.openToggle(false);
        window.location.href = `https://www.mobox.io/login/register/phone?redirect=${encodeURIComponent(window.location.href)}`;
      // this.$refs.register.step = 0;
      // this.isShowRegister = true;
    },
    logout(){
        this.$store.commit("globalState/logout");
    },
    toDownLoad(){
      window.open(`${OLDPAGE}#/?toDownLoad=true`)
    },
    toggleLoginModal(){
        // this.openToggle(false);
        // this.isShowLogin = !this.isShowLogin;

        window.location.href = `https://www.mobox.io/login/?redirect=${encodeURIComponent(window.location.href)}`
    },

    openToggle(isShow) {
      const $body = $(document.getElementsByTagName("body"));
      this.showMobileMenu = isShow;

      if (isShow) {
        $body.addClass("no-scroll");
      } else {
        $body.removeClass("no-scroll");
      }
    },
    toLink(key) {
      switch (key) {
        case `farm`:
          window.open(`${OLDPAGE}#/iframe/momo`);
          break;
        case `nftmarket`:
          window.open(`${OLDPAGE}#/iframe/momo?path=market&tab=0`);
          break;
        case `docs`:
          window.open("https://faqen.mobox.io/");
          break;
      }
    },
    toGame(name) {
      switch (name) {
        case `cz`:
          window.open(`${OLDPAGE}#/iframe/chainzarena`);
          break;
        case `towerdefense`:
          window.open(`${OLDPAGE}#/iframe/mobox_tower_defense`);
          break;
        case `block`:
          window.open(`${OLDPAGE}#/block-brawler`);
          break;
        case `token`:
          window.open(`${OLDPAGE}#/iframe/tokenmaster`);
          break;
        case `contest`:
          window.open(`${OLDPAGE}#/iframe/contest`);
          break;
      }
    },
    toGover(key) {
      switch (key) {
        case `vote`:
          window.open(`${OLDPAGE}#/governance/list?tab=momo`);
          break;
        case `community`:
          window.open(`https://www.mobox.io/community/`);
          break;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  transition: all 0.8s;

  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  height: 70px;

  z-index: 1;

  background: #282b2f;
  .lang-area{
    margin-left: 20px;
    display: flex;
    align-items: center;
    justify-content: right;
    padding-right: 20px;
  }

    .mobile-tabbar{
        background: #202226;
        border-radius: 25px;
        color: white;

        .user-menu{
            left: 10px!important;
            transform: none!important;
        }

        .dropdown-value{
            border: none!important;
            padding: 0px !important;
        }
    }

    .menu {
        padding: 18px 0;
        height: 100%;
        box-sizing: border-box;
        position: relative;

        display: flex;
        align-items: center;
    
        li {
            height: 100%;
            font-size: 14px;
            color: #ffffff;
            padding: 0 10px;
            margin: 0 5px;
        }
    
        .user-menu {
            display: none;
    
            -webkit-backdrop-filter: blur(5px);
            backdrop-filter: blur(5px);
            outline: none;
    
            background: rgba(25, 27, 32, 0.5);
            border: 1px solid #444548;
            box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.75);
            border-radius: 10px;
    
            position: absolute;
            left: 50%;
            top: 60px;
            transform: translate(-50%, 0);
            color: white;

    
            .user-menu-item {
                transition: 0.3s all;
                cursor: pointer;
                width: 200px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 15px;
                // background: linear-gradient(90deg, rgba(36,84,198, 0) 0%, rgba(18,42,99, 0) 100%);;
        
                .item-left {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
        
                .label-head {
                    margin-right: 10px;
                }
                }
        
                .user-menu-item:hover {
                background: linear-gradient(
                    90deg,
                    rgba(36, 84, 198, 0.2) 0%,
                    rgba(18, 42, 99, 0.2) 100%
                );
            }
    
            .user-menu-logout {
                transition: 0.3s all;
                cursor: pointer;
                width: 200px;
                display: flex;
                justify-content: center;
                align-items: center;
                // background: linear-gradient(90deg, rgba(36,84,198, 0) 0%, rgba(18,42,99, 0) 100%);
                height: 40px;
        
                img {
                    width: 12px;
                    margin: 0 5px;
                }
            }
    
            .user-menu-logout:hover {
            background: linear-gradient(
                90deg,
                rgba(36, 84, 198, 0.2) 0%,
                rgba(18, 42, 99, 0.2) 100%
            );
            }
    
            .sanjiao {
            width: 0;
            height: 0;
            border-top: 5px solid transparent;
            border-bottom: 5px solid transparent;
            border-left: 5px solid #ff9959;
            }
        }
    
        // 用户信息
        .user-info {
            display: flex;
            align-items: center;
    
            .user-head {
            width: 34px;
            height: 34px;
            margin-right: 10px;
    
            img {
                width: 100%;
            }
            }
    
            span {
            font-size: 12px;
            font-weight: 600px;
            }
    
            .sanjiao {
            margin-left: 5px;
            width: 0;
            height: 0;
            border-right: 3px solid transparent;
            border-left: 3px solid transparent;
            border-top: 3px solid #fff;
            }
        }
    
        .connect-wallet,
        .register {
            border-radius: 25px;
        }
    
        // 注册
        .register {
            padding: 8px 16px;
            background: linear-gradient(90deg, #4071d7 0%, #344da7 100%);
        }
    
        // 链接钱包
        .connect-wallet {
            background: #191b20;
        }
    }

    .downarea {
        padding: 20px;
        cursor: pointer;
        position: relative;
        display: flex;

        .select-area {
            color: white;
            display: flex;
            justify-content: center;
            align-items: center;

            .sanjiao {
                margin-left: 5px;
                width: 0;
                height: 0;
                border-right: 3px solid transparent;
                border-left: 3px solid transparent;
                border-top: 3px solid #fff;
            }
        }

        .down-menu {
            -webkit-backdrop-filter: blur(5px);
            backdrop-filter: blur(5px);

            display: none;

            background: rgba(25, 27, 32, 0.5);
            border: 1px solid #444548;
            box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.75);
            border-radius: 10px;
            width: 200px;

            position: absolute;
            right: 0;
            top: 60px;

            padding: 20px 0;

            flex-direction: column;
            justify-content: center;
            align-items: center;

            .line {
                height: 2px;
                background: #4b4c4f;
                margin: 10px 0;
                width: 80%;
            }

            .downlaod-itembox {
                color: #fc9b65;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                text-align: center;
                font-size: 14px;

                .qrcode {
                width: 150px;
                margin-bottom: 10px;
                }
            }
        }
    }

    .downarea:hover {
        .down-menu {
        display: flex;
        }
    }

  // 右侧菜单
    .right-menu{
        position: absolute;
        top: 50%;
        right: 0;
        transform: translate(0, -50%);
        display: flex;
        padding-right: 30px;

        ul {
            list-style: none;
            display: flex;

            li {
            cursor: pointer;
            display: flex;
            align-items: center;
            height: 100%;
            font-size: 14px;
            }

            .li-class {
            font-weight: bold;
            cursor: pointer;
            display: flex;
            align-items: center;
            height: 100%;
            font-size: 14px;
            color: #9a9a9a;
            padding: 0 20px;
            opacity: 0.6;
            }

            .mobile-li-class{
            font-weight: bold;
            cursor: pointer;
            display: flex;
            align-items: center;
            height: 100%;
            font-size: 14px;
            color: #fab408;
            padding: 10px 30px;
            }
        }
    }

  .menu:hover {
    .user-menu {
      display: block;
    }
  }

  .head-footer {
    position: absolute;
    bottom: 20px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    margin: 10px 0;

    a {
      display: inline-block;
      vertical-align: middle;
      margin: 0 15px;
      img {
        cursor: pointer;
        margin: 0 5px;
        vertical-align: middle;
        height: 20px;
      }
    }

    .link {
      display: inline-block;
      vertical-align: middle;
      position: relative;
      overflow: hidden;

      .icon {
        cursor: pointer;
        margin: 0 5px;
        vertical-align: middle;
        height: 28px;
      }

      .code {
        position: absolute;
        width: 200px;
        bottom: 35px;
        right: 0;

        opacity: 0;
        transition: 0.2s all;
      }
    }

    .link:hover {
      overflow: initial;
      .code {
        opacity: 1;
      }
    }
  }

  .nav-btn-toggle {
    position: fixed;
    height: 100%;
    width: 100%;
    top: 70px;
    z-index: 99;

    ul {
      flex-direction: column;
    }

    li {
      width: 100%;
      height: 49px;
      font-weight: bold;
      padding-left: 30px;
      display: flex;
      align-items: center;

      color: #fab408;
      font-size: 14px;

      &.router-link-active {
        // background: rgba(36,84,198, 0.5);
        color: #fab408;
        // background: rgba(36, 84, 198, 0.5);
        // border-left: 3px solid #65bdfe;
        box-shadow: 0px 3px 12px rgba(117, 115, 151, 0.1);
      }
    }

    span {
      margin-right: 10px;
    }

    .menu-item {
      display: block;
      height: auto;
    }

    .nav-box {
      height: 49px;
      display: flex;
      align-items: center;
      color: #fff;
    }

    // 二级菜单
    .mobile-sub-menu {
      padding-left: 25px;

      a {
        display: flex;
        height: 40px;
        align-items: center;
        color: #fab408 !important;
        text-decoration: none;
      }
    }
  }

  .mobile-menu {
    .mobile-bg {
      position: fixed;
      z-index: 90;
      top: 68px;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(16, 15, 15, 0.9);
      -webkit-backdrop-filter: blur(5px);
      backdrop-filter: blur(5px);
    }
  }

  .select-item {
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .sub-menu {
    position: absolute;
    width: 246px;
    left: 0;
    top: 100%;
    display: none;
    background: rgba(25, 27, 32, 0.6);
    border: 1px solid #444548;
    box-shadow: 3px 3px 6px rgb(0 0 0 / 75%);
    border-radius: 10px;
    backdrop-filter: blur(5px);

    .sub-menu-item {
      display: block;

      &:hover,
      & /deep/ .router-link-active {
        background: linear-gradient(
          90deg,
          rgba(36, 84, 198, 0.2) 0%,
          rgba(18, 42, 99, 0.2) 100%
        );
      }

      .sub-menu-box {
        padding: 20px 25px 20px 18px;
        display: flex;
        white-space: nowrap;
        line-height: 34px;
        align-items: center;

        span {
          text-align: left;
        }
      }

      // 游戏logo
      .logo {
        width: 55px;
        margin-right: 8px;
      }

      // 名称
      .name {
        flex: 1;
      }

      .iconfont {
        font-size: 8px;
        color: #ff9959;
      }
    }

    a {
      display: flex;
      height: 40px;
      align-items: center;
      color: #fab408 !important;
    }
  }

  .nav-select {
    position: relative;
  }

  .nav-select:hover {
    .sub-menu {
      display: block;
    }
  }

  .header-elements {
    height: 100%;
    display: flex;
    align-items: center;
    padding-left: 40px;

    color: white;

    .mobile-btns {
      position: absolute;
      left: 20px;

      .nav-btn {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .close {
        position: relative;
        width: 40px;
        height: 40px;
      }

      .close::before,
      .close::after {
        position: absolute;
        content: " ";
        background-color: #fff;
        top: 10px;
        left: 10px;
        width: 2px;
        height: 20px;
      }

      .close::before {
        transform: rotate(45deg);
      }

      .close::after {
        transform: rotate(-45deg);
      }
    }

    .logo {
      height: 50%;
      margin-right: 50px;
    }

    .select-item {
      font-weight: bold;
      font-size: 15px;
      cursor: pointer;
      min-width: 140px;
      text-align: center;
    }
  }
}

.hide-header {
  top: -70px;
}
</style>